// extracted by mini-css-extract-plugin
export default {"List":"LawList_List__jLLsz","TableWrapper":"LawList_TableWrapper__OsHeF"};